import { browser } from '$app/environment';
import * as Sentry from '@sentry/browser';

const maxSentryRuns = 100;
let currentSentryRuns = 1;

const isPageLoadException = (e) => {
  return (
    e &&
    e.reason &&
    e.reason.message &&
    e.reason.message.includes('fetch dynamically imported') &&
    e.reason.message.includes('/pages/')
  );
};

export default {
  init: () => {
    if (browser && window.APP_ENV !== 'development') {
      var sentryInterval = setInterval(() => {
        clearInterval(sentryInterval);

        let dsn =
          window.APP_ENV === 'staging'
            ? 'https://12456f3d1e24175ce71d1f7cc5342526@o404582.ingest.sentry.io/4505941272690688'
            : 'https://4cd89dcbfd494e25bb341f193e3f0321@o404582.ingest.sentry.io/5268736';

        Sentry.init({
          dsn: dsn,
          ignoreErrors: [
            'Non-Error exception captured',
            'Non-Error promise rejection captured',
            'Object captured as promise rejection with keys',
          ],
          initialScope: (scope) => {
            scope.setTags({ 'app-version': window.APP_VERSION });
            return scope;
          },
          beforeSend: (event, hint) => {
            const error = hint.originalException;

            if (isPageLoadException({ reason: error })) {
              console.log('Skipped sending error to sentry', error);
              return null;
            }

            return event;
          },
        });

        if (currentSentryRuns > maxSentryRuns) {
          clearInterval(sentryInterval);
        }

        currentSentryRuns += 1;
      }, 100);
    }
  },

  isPageLoadException: isPageLoadException,

  capture: (msg) => {
    Sentry.captureMessage(msg);
  },
};
